import { render } from "./Typography.vue?vue&type=template&id=cbcf8b96&scoped=true"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"

import "./Typography.vue?vue&type=style&index=0&id=cbcf8b96&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbcf8b96"]])

export default __exports__